import Home from './Home.bundle-pool.vue'

export default {
  Home
}